import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMail = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "none",
	height: 26,
	viewBox: "0 0 26 26",
	width: 26,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m22.4502 5.125h-18.9c-.20886 0-.40917.08297-.55685.23065-.14769.14769-.23065.34799-.23065.55685v13.3875c0 .4177.16593.8183.4613 1.1137s.69598.4613 1.1137.4613h17.325c.4177 0 .8183-.1659 1.1137-.4613s.4613-.696.4613-1.1137v-13.3875c0-.20886-.083-.40916-.2307-.55685-.1476-.14768-.3479-.23065-.5568-.23065zm-2.0249 1.575-7.4251 6.807-7.42515-6.807zm1.2374 12.6h-17.325v-11.59692l8.1299 7.45272c.1453.1334.3354.2074.5326.2074s.3873-.074.5325-.2074l8.13-7.45272z",
		fill: "#000"
	})
});
export default SvgMail;
